const errorReducer = (state, action) => ({
  ...state,
  errors: action.errors,
  errorMessage: action.errorMessage,
  isLoading: false,
});

export default errorReducer;
